<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Memories</h4>
                            <p class="card-category"></p>

                            <div class="row mt10">

                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="status" id="status-filter"
                                                @change="saveFilters('ctt_status', status)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">Опубликовано</option>
                                            <option value="0">Ожидает</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="form-group">
                                        <label class="control-label">Copyrighted</label>
                                        <select v-model="isCopyrighted" id="trendy-filter"
                                                @change="saveFilters('ctt_is_copyrighted', isCopyrighted)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="0">Free</option>
                                            <option value="1">Copyrighted</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="form-group">
                                        <label class="control-label">New</label>
                                        <select v-model="isNew" id="trendy-filter"
                                                @change="saveFilters('ctt_is_new', isNew)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">New</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-4"></div>
                                <div class="col-md-3" v-if="role < 2">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Добавить шаблон
                                    </button>
                                </div>
                            </div>
                        </template>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'preview_src_full'">превью</span>
                                        <span v-else-if="column === 'counter'">экспорт</span>
                                        <span v-else-if="column === 'category'">категория</span>
                                        <span v-else-if="column === 'push_type'">тип</span>
                                        <span v-else-if="column === 'status'">статус</span>
                                        <span v-else-if="column === 'sort'">сортировка</span>
                                        <span v-else-if="column === 'videos'">количество видео</span>
                                        <span v-else-if="column === 'duration'">длительность, сек.</span>
                                        <span v-else-if="column === 'release_date'">дата публикации</span>
                                        <span v-else-if="column === 'is_premium'">премиум</span>
                                        <span v-else-if="column === 'is_trendy'">популярное</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <div v-if="column === 'preview_src_full'" @click="edit(item['id'])">
                                                <div class="device-block device1" v-if="!isVideo(item[column])"
                                                     :style="{ backgroundImage: 'url(' + item[column] + ')' }">
                                                </div>
                                                <div class="device-block device1" v-if="isVideo(item[column])">
                                                    <video muted loop autoplay playsinline id="video_player"
                                                           :key="item[column]"
                                                           style="max-width: 100%; cursor: pointer;">
                                                        <source :src="item[column]"/>
                                                    </video>
                                                </div>
                                            </div>
                                            <span v-else-if="column === 'color'  && item[column]"
                                                    class="color-block"
                                                  :style="{ backgroundColor: '#' + item[column] }"></span>
                                            <span v-else-if="column === 'color_group' && item[column]"
                                                  class="color-block"
                                                  :style="{ backgroundColor: '#' + item[column] }"></span>
                                            <span v-else-if="column === 'name'">
                                                <a v-if="role < 2" class="text-default" @click="edit(item['id'])">{{ item[column] }}</a>
                                            </span>
                                            <span v-else-if="column === ''">
                                                <a v-if="role < 2" class="text-primary" @click="edit(item['id'])">Изменить</a>
                                            </span>
                                            <span v-else-if="column === 'status'">
                                                <span class="text-success" v-if="item[column] === 1">Опубликовано</span>
                                                <span class="text-warning" v-if="item[column] === 0">Ожидает</span>
                                            </span>
                                            <span v-else-if="column === 'push_type'">
                                                <img class="premium" src="/static/img/push.png" v-if="item[column] !== 0"/>
                                            </span>
                                            <span class="" v-else-if="column === 'release_date'">
                                                {{ item[column] | toEasyDate }}
                                            </span>
                                            <span class="" v-else-if="column === 'duration'">
                                                <span :class="{ 'bg-danger' : isWrongDuration(item) }">{{ item[column] }}</span>
                                            </span>
                                            <span v-else-if="column === 'is_premium'">
                                                <img class="premium" src="/static/img/premium.png" v-if="item[column] === 1"/>
                                            </span>
                                            <span class="emodji" v-else-if="column === 'is_trendy'">
                                                <span class="text-success" v-if="item[column] === 1">🖤</span>
                                                <span class="text-warning" v-if="item[column] === 0"></span>
                                            </span>
                                            <span v-else-if="column === 'type'">
                                                <img class="premium" src="/static/img/live.png" v-if="item[column] === 2"/>
                                            </span>
                                            <span v-else>{{item[column]}}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            След.
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Пред.
                        </div>

                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
    const _ = require('lodash')
    const axios = require('axios')
    const moment = require('moment')
    import LTable from 'src/components/UIComponents/Table.vue'
    import Card from 'src/components/UIComponents/Cards/Card.vue'

    export default {
        components: {
            LTable,
            Card
        },
        created: function () {
            let self = this;

            let token = localStorage.getItem('token');

            axios.get(
                `${this.$hostname}/admin/categories/`,
                {
                    'params': {

                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.loading = false;
                    self.categories = response.data;

                    self.get();
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                });
        },
        data() {
            return {
                columns: ['id', 'name', 'is_premium', 'push_type', 'videos', 'duration', 'sort', 'status', ''],
                data: [],
                role: parseInt(localStorage.getItem('role')) || 0,
                categoryId: localStorage.getItem('ctt_category') ? localStorage.getItem('ctt_category') : "",
                status: localStorage.getItem('ctt_status') ? localStorage.getItem('ctt_status') : "",
                isTrendy: localStorage.getItem('ctt_is_trendy') ? localStorage.getItem('ctt_is_trendy') : "",
                isCopyrighted: localStorage.getItem('ctt_is_copyrighted') ? localStorage.getItem('ctt_is_copyrighted') : "",
                isNew: localStorage.getItem('ctt_is_new') ? localStorage.getItem('ctt_is_new') : "",
                categories: [],
                filteredId: null,
                limit: 10,
                offset: parseInt(localStorage.getItem('ctt_active_offset')) || 0,
            }
        },
        filters: {
            toEasyDate (value) {
                if (value) {
                    return moment(String(value)).format('DD.MM.YYYY HH:mm')
                } else {
                    return '';
                }
            },
            toShortText (value) {
                if (value) {
                    return value.length > 10 ? value.substr(0, 10) + '...' : value.substr(0, 10)
                } else {
                    return '';
                }
            }
        },
        methods: {
            isVideo: function(url) {
                return url.indexOf('.mp4') > -1;
            },
            isWrongDuration: function (template) {

                let sum = 0;
                _.map(template.parts, (p) => {
                    if (isNaN(parseFloat(p.duration))) {
                        sum += 0;
                    } else {
                        sum += parseFloat(p.duration);
                    }
                })

                return parseFloat(sum.toFixed(2)) !== template.duration;
            },
            add: function () {
                this.$router.push('/memories/create');
            },
            filter: function () {
                localStorage.setItem('ctt_active_offset', "0");
                this.offset = 0;
                this.get();
            },
            edit: function (id) {
                if (this.role > 1) {
                    return false;
                }
                //localStorage.setItem('w_last_opened_id', parseInt(id));
                this.$router.push({
                    name: 'edit-for-you',
                    params: {id: id}
                });
            },
            get: function () {
                let self = this;

                let token = localStorage.getItem('token');

                let status = this.status === null ? '' : this.status;
                let isCopyrighted = this.isCopyrighted === null ? '' : this.isCopyrighted;
                let isNew = this.isNew === null ? '' : this.isNew;
                let filteredId = this.filteredId === null ? '' : this.filteredId;

                axios.get(
                    `${this.$hostname}/admin/created`,
                    {
                        'params': {
                            status: status,
                            isCopyrighted: isCopyrighted,
                            isNew: isNew,
                            limit: self.limit,
                            offset: self.offset,
                            filteredId: filteredId
                        },
                        'headers': {
                            'Authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        let data = response.data;

                        self.data = data.templates;
                    })
                    .catch(function (error) {
                        console.log(error)
                    })

            },
            prev: function () {
                if (this.offset >= this.limit) {
                    this.offset -= this.limit;
                    this.get();
                    localStorage.setItem('ctt_active_offset', parseInt(this.offset));
                }
            },
            next: function () {
                if (this.data.length === this.limit) {
                    this.offset += this.limit;
                    this.get();
                    localStorage.setItem('ctt_active_offset', parseInt(this.offset));
                }
            },
            saveFilters: function(name, value) {
                localStorage.setItem(name, value);
            }
        },
        beforeRouteLeave (to, from , next) {
            if (to.path.indexOf('templates') < 1) {
                localStorage.setItem('ctt_active_offset', "0");
                localStorage.setItem('ctt_category', "");
                localStorage.setItem('ctt_status', "");
                localStorage.setItem('ctt_is_trendy', "");
                localStorage.setItem('ctt_is_copyrighted', "");
            }
            next();
        },
    }
</script>
<style scoped>
    .pagination-button {
        height: 30px;
        padding: 1px 16px;
        margin-left: 20px;
        color: #fff !important;
    }
    .pagination-button.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
    .text-primary {
        cursor: pointer;
    }
    .text-default {
        cursor: pointer;
        color: #000;
    }
    .stats-block {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .stats-block > span {
        display: block;
        width: 100%;
        margin-left: 15px;
        margin-bottom: 3px;
    }
    .stats-block span span.number {
        font-weight: 700;
        font-size: 18px;
    }
    .wallpapers-preview {
        cursor: pointer;
        max-height: 200px;
    }

    .mt10 {
        margin-top: 10px;
    }

    .btn-fill {
        margin-top: 25px;
    }
    .premium {
        width: 30px;
        margin-left: 20px;
    }

    .device-block {
        position: relative;
        background-position: center center;
        background-size: cover;
        cursor: pointer;
    }
    .device-block img {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 18px;
        top: 18px;
    }
    .device-block span {
        position: absolute;
        top: -30px;
        left: 5px;
    }
    .bg-danger {
        font-size: 18px;
        padding: 3px;
        border-radius: 4px;
        background-color: rgba(255, 70, 50, 0.5) !important;
    }
    .device1 {
        display: block;
        width: 140px;
        height: 248px;
        border-radius: 8px;
        overflow: hidden;
    }
    .mt30 {
        margin-top: 30px;
    }
    .emodji {
        font-size: 24px;
    }
    .color-block {
        display: block;
        width: 50px;
        height: 50px;
    }
    th {
        padding: 12px 8px;
    }
    .premium {
        width: 30px;
        margin-left: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Memories.vue